import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import SponsoredLabel from './SponsoredLabel'

const SPONSORED_LABEL_INLINE_STYLE = { marginInlineStart: rem(8), verticalAlign: 'middle' as const, position: 'relative' as const, top: rem(-3) }

interface Props extends PropsWithChildren {
  sponsored?: boolean
}

function SearchTileRowTitle({ children, sponsored = false }: Props) {
  return <Heading variant="heading5" lineClamp={3}>
    {children}
    {sponsored && (
      <span style={SPONSORED_LABEL_INLINE_STYLE}>
        <SponsoredLabel />
      </span>
    )}
  </Heading>
}

export default SearchTileRowTitle
